// extracted by mini-css-extract-plugin
export default {"container":"Zux23k"};